import { RefObject } from "react";
import { useQuery } from "@tanstack/react-query";
import { useOutletContext } from "react-router-dom";
import { projectQueries } from "@entities/project";
import { useLegacyIframe } from "@features/builddocs-iframe";
import { useCoordinator } from "@shared/lib/hooks";
import { routes } from "@shared/lib/react-router";

export function ProjectRegistry() {
  const { projectId } = useCoordinator();
  const { data: project } = useQuery(projectQueries.getProject({ projectId }));

  const { wrapperRef } = useOutletContext() as {
    wrapperRef: RefObject<HTMLDivElement>;
  };

  useLegacyIframe({
    parentRef: wrapperRef,
    route: routes.project.actRegistry(project?.externalId),
  });

  return <></>;
}
